import type { IControllerConstructor, IDirective, Injectable } from "angular";
import { module } from "angular";

import SvgImageCanvasDirectiveController from "./SvgImageCanvasDirectiveController";

import "./SvgImageCanvas.scss";

export default class SvgImageCanvasDirective implements IDirective {
    public bindToController = {
        image: "<mmSvgImageCanvas",
    };

    public controller: Injectable<IControllerConstructor>;

    public controllerAs = "$ctrl";

    public restrict = "A";

    public scope = {};

    constructor() {
        this.controller = SvgImageCanvasDirectiveController;
    }
}

module("mmGui").directive("mmSvgImageCanvas", () => new SvgImageCanvasDirective());
